import { IBannerLocale } from '@/models/banners.model';

export enum BannersFiltersFields {
  TITLE = 'title',
  DESCRIPTION = 'description',
  START_DATE = 'start_date',
  END_DATE = 'expiration_date',
  ACTIVE = 'active',
  LIMIT = 'limit',
}

export enum BannersFields {
  START_DATE = 'start_date',
  END_DATE = 'expiration_date',
  ACTIVE = 'active',
  WEB_MEDIA = 'web_media',
  MOBILE_MEDIA = 'mobile_media',
  LOCALE = 'locale',
}

export type TGetBannersQuery = {
  [BannersFiltersFields.TITLE]?: string;
  [BannersFiltersFields.DESCRIPTION]?: string;
  [BannersFiltersFields.START_DATE]?: string;
  [BannersFiltersFields.END_DATE]?: string;
  [BannersFiltersFields.ACTIVE]?: '0' | '1';
  [BannersFiltersFields.LIMIT]?: number;
  page?: number;
};

export type TBannerFormValues = {
  [BannersFields.START_DATE]: string;
  [BannersFields.END_DATE]: string;
  [BannersFields.ACTIVE]: '1' | '0';
  [BannersFields.WEB_MEDIA]: Blob;
  [BannersFields.MOBILE_MEDIA]: Blob;
  [BannersFields.LOCALE]: IBannerLocale;
};
